import clienteAxios from "../../../config/axios";
import { FechaExacta } from "../../../config/const";

// actaEstado
// actaCiudad
// actaSector
// actaDocCliente
// actaTipo
// actaOpcion
// actaServiciosVisita
// correo_nuevo_registro
// eco_fec_reg

// autocompleteDinamico
// variante: "autocompleteDinamico",
// propiedadesMostrar: 2,
// campoData1: "perDocNumero",
// campoData2: "perNombre",
// getData: async (data) => {
//   if (data.length < 3) {
//     return;
//   }
//   const res = await clienteAxios.get(
//     `/proveedores/filtro/0?empresa=${
//       usuario.rucempresa
//     }&search=${data}&estado=${"PROVEEDOR"}&tabla=compras`
//   );
//   return res;
// },
// },

// autocompleteComun
// variante: "autocompleteComun",
// data: [
//   "APERTURA",
//   "INGRESO",
//   "EGRESO",
//   "DEPOSITO",
//   "CAJA CHICA",
//   "TRANSFERENCIA",
// ],
// autocompleteDataDefault
// variante: "autocompleteDataDefault",
// propiedadesMostrar: 1,
// campoData1: "fpagoNombre",
// getData: async () => {
// const resciudadesData = await clienteAxios.get(`/ciudades/filtro/0`);

// setciudadesData(resciudadesData.data.data);
// },
// propiedad: "venFormaPago",
export const columns = [
  {
    id: "eco_id",
    label: "Codigo",
    minWidth: 2,
    tipo: "string",
    propiedad: "eco_id",
  },
  {
    id: "eco_nombre_mascota",
    label: "Paciente",
    minWidth: 2,
    tipo: "string",
    propiedad: "eco_nombre_mascota",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "mascNombre",
    campoData2: "mascPerNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(`/mascotas/filtro/0?search=${data}`);
      return res;
    },
  },
  {
    id: "eco_id_propietario",
    label: "Propietario",
    minWidth: 150,
    tipo: "string",
    propiedad: "eco_id_propietario",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "perDocNumero",
    campoData2: "perNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(
        `/proveedores/filtro/0?search=${data}&estado=CLIENTE`
      );
      return res;
    },
  },
  {
    id: "eco_id_medico",
    label: "Doctor",
    minWidth: 150,
    tipo: "string",
    propiedad: "eco_id_medico",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "perDocNumero",
    campoData2: "perNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(
        `/proveedores/filtro/0?search=${data}&estado=VETERINARIO`
      );
      return res;
    },
  },
  {
    id: "eco_observacion",
    label: "Observación",
    minWidth: 2,
    tipo: "",
    propiedad: "eco_observacion",
  },
  {
    id: "eco_usuario",
    label: "User",
    minWidth: 2,
    tipo: "string",
    propiedad: "eco_usuario",
  },
  {
    id: "eco_fec_upd",
    label: "Fec Upd",
    minWidth: 50,
    tipo: "numero",
    propiedad: "eco_fec_upd",
  },
];
export const validacion = (item, setitem, seterror) => {
  const { eco_nombre_mascota, eco_nombre_medico } = item;

  if (eco_nombre_mascota.trim() === "" || eco_nombre_medico.trim() === "") {
    seterror({
      eco_nombre_mascota: eco_nombre_mascota.trim() === "",
      eco_nombre_medico: eco_nombre_medico.trim() === "",
    });
    return true;
  }
};
export const objectDefault = {
  // --- Mascota ---
  eco_id_mascota: "",
  eco_nombre_mascota: "",
  eco_raza_mascota: "",
  eco_especie_mascota: "",
  eco_sexo_mascota: "",
  eco_edad_mascota: "",
  eco_peso_mascota: 0,

  // --- Propietario ---
  eco_id_propietario: "",
  eco_nombre_propietario: "",
  eco_email_propietario: [],

  // --- Médico ---
  eco_id_medico: "",
  eco_nombre_medico: "",

  // --- Información general ---
  eco_fecha: FechaExacta,
  eco_usuario: "",
  eco_empresa: "",
  eco_archivo: "",
  eco_eliminado: "NO",
  eco_eliminado_descripcion: "",
  eco_observacion: "",
  eco_fec_reg: "",
  eco_fec_upd: "",

  // eco_id:

  eco_paciente_externo: "NO",
  eco_ecografia: "Ecografía", //,'Abdomen','Toráx','Otro'",
  eco_centro_veterinario: "",
  eco_dato_cobro: "",
  eco_cancelado: "NO",
  eco_motivo_estudio: "",
  eco_sospecha_clinica: "",

  // --- Resultados de laboratorio ---
  eco_quimica_sanguinea: [],
  eco_hematologia: [],
  eco_hemostasia_coagulacion: [],
  eco_paneles_bioquimica: [],
};
